(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .factory('fileAcceptCompiler', fileAcceptCompilerFactory);

    fileAcceptCompilerFactory.$inject = [];
    function fileAcceptCompilerFactory() {
        var rAccept = /(?:[\s,]+|^)(?:(\.\w+)|(?:((?:audio|video|image)\/)\*)|([^,]+?))(?=(\s*,\s*|$))/ig;
        return fileAcceptCompiler;

        function fileAcceptCompiler(accept) {
            var match, sb = [];
            if (!(accept || '').trim())
                return alwaysTrue;
            accept = accept.toLowerCase();
            rAccept.lastIndex = 0;
            while (match = rAccept.exec(accept)) {
                (match[1] && sb.push(hasExtension.bind(match[1]))) ||
                (match[2] && sb.push(typeStartsWith.bind(match[2]))) ||
                (match[3] && sb.push(typeEquals.bind(match[3])));
            }

            return isAcceptable

            function isAcceptable(file) {
                return sb.some(function (func) {
                    return !!file && func(file);
                });
            }
            function hasExtension(file) {
                return file.name && file.name.toLowerCase().endsWith(this);
            }
            function typeStartsWith(file) {
                return file.type && file.type.toLowerCase().startsWith(this);
            }
            function typeEquals(file) {
                return file.type && file.type.toLowerCase() === this;
            }
            function alwaysTrue(file) {
                return true;
            }
        }
    }
})();